import { render, staticRenderFns } from "./StudentCourseList.vue?vue&type=template&id=e867abb2&scoped=true"
import script from "./StudentCourseList.vue?vue&type=script&lang=js"
export * from "./StudentCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e867abb2",
  null
  
)

export default component.exports